import { render, staticRenderFns } from "./EditRemarks.vue?vue&type=template&id=7593f3d3&scoped=true"
import script from "./EditRemarks.vue?vue&type=script&lang=js"
export * from "./EditRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7593f3d3",
  null
  
)

export default component.exports